import React from "react";
import { formatPrice, handleOpenInNew } from "../../utils";
import {
  AmountPaid,
  CustomerNameAndNumberInSaleRow,
  Item,
  Parent,
} from "./BatchSaleRow";
import EventTicketChip from "./EventTicketChip";
import { WhatsApp } from "@mui/icons-material";
import { AddFlex, CustomText } from "../../reusableStyles";
import { format } from "date-fns";
import { Divider } from "@mui/material";

function TravelSaleRow({ index, headerList, sale }) {
  return (
    <div>
      <Parent>
        <Item justify="flex-start" percent={headerList[0][0]}>
          <CustomerNameAndNumberInSaleRow sale={sale} />
        </Item>

        <Item percent={headerList[1][0]}>
          <AddFlex flexDirection="column" justify="center" align="center">
            <div>{format(new Date(sale.saleDate), "dd MMM yyyy")}</div>
            <div style={{ fontSize: "12px", marginTop: "5px" }}>
              {format(new Date(sale.saleDate), "hh:mm a")}
            </div>
          </AddFlex>
        </Item>

        <Item percent={headerList[2][0]}>
          <EventTicketChip sale={sale} />
        </Item>
        <Item percent={headerList[3][0]}>
          <AmountPaid
            totalAmount={sale.ticketPrice}
            couponCode={sale.saleObj.data.couponCode}
            currency={sale.saleObj.data.paymentBreakdown.currency}
            forexConversionRate={
              sale.saleObj.data.paymentBreakdown.forexConversionRate
            }
            ticketPriceAfterDiscount={sale.ticketPriceAfterDiscount}
          />
        </Item>
      </Parent>
      <Divider />
    </div>
  );
}

export default TravelSaleRow;
